import { useTranslation } from 'react-i18next';
import {
  ACTIVITY_CATEGORY_FILTERS,
  type ActivityCategoryFilter as CategoryFilterValue,
} from '@/constants/activityLog';
import { cn } from '@/lib/utils';

interface ActivityCategoryFilterProps {
  value: CategoryFilterValue;
  onChange: (nextValue: CategoryFilterValue) => void;
}

export function ActivityCategoryFilter({ value, onChange }: ActivityCategoryFilterProps) {
  const { t } = useTranslation('activity');
  return (
    <div
      role="group"
      aria-label={t('filter.label')}
      className="grid grid-cols-2 sm:inline-flex bg-zoowhite border border-zooborder rounded-xl p-1 self-start"
    >
      {ACTIVITY_CATEGORY_FILTERS.map(function renderOption(option) {
        const isSelected = value === option;
        return (
          <button
            key={option}
            type="button"
            aria-pressed={isSelected}
            onClick={function select() {
              onChange(option);
            }}
            className={cn(
              'px-3 sm:px-4 py-2 rounded-lg text-xs font-bold transition-colors',
              isSelected ? 'bg-zooprimary text-zoowhite' : 'text-zoomuted'
            )}
          >
            {t('filter.' + option)}
          </button>
        );
      })}
    </div>
  );
}
